import React, { useState, forwardRef, useImperativeHandle } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './floating-filter-style.css';

const DateFloatingFilter = forwardRef((props: any, ref) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useImperativeHandle(ref, () => ({
    onParentModelChanged(parentModel: any) {
      if (!parentModel) setSelectedDate(null);
    },
  }));

  const handleChange = (date: Date | null) => {
    setSelectedDate(date);

    props.parentFilterInstance((instance: any) => {
      if (date) {
        const formattedDate = date.toLocaleDateString("en-CA"); 
        instance.onFloatingFilterChanged("equals", formattedDate);
      } else {
        instance.onFloatingFilterChanged(null, null);
      }
    });
  };

  return (
    <div className="floating-filter-container">
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        placeholderText="Select date"
        dateFormat="yyyy-MM-dd"
        isClearable
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        yearDropdownItemNumber={15}
        portalId="root-portal"
        className="floating-filter-input" 

        popperContainer={({ children }) => <div style={{ zIndex: 9999 }}>{children}</div>}

      />
    </div>
 
    
  );
});

export default DateFloatingFilter;
